import * as ActionTypes from './index';
import {actionCreator} from "../helpers/functions";

export const fetchApplicationByIdAfterApplicationUpdate = actionCreator(
    ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_UPDATE
);

export const fetchApplicationByIdAfterApplicationUpdateSuccess = actionCreator(
    ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_UPDATE_SUCCESS
);

export const fetchApplicationByIdAfterApplicationUpdateFailed = actionCreator(
    ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_UPDATE_FAILED
);

export const fetchApplicationByIdAfterApplicationAnswerUpdate = actionCreator(
    ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_ANSWER_UPDATE
);

export const fetchApplicationByIdAfterApplicationAnswerUpdateSuccess= actionCreator(
    ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_ANSWER_UPDATE_SUCCESS
);

export const fetchApplicationByIdAfterApplicationAnswerUpdateFailed = actionCreator(
    ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_ANSWER_UPDATE_FAILED
);


export function openEditQuestionAnswerModal(payload) {
    return {
        type: ActionTypes.OPEN_EDIT_QUESTION_ANSWER_MODAL,
        payload: payload
    }
}

export function closeEditQuestionAnswerModal(payload) {
    return {
        type: ActionTypes.CLOSE_EDIT_QUESTION_ANSWER_MODAL,
        payload: payload
    }
}

export function updateFormQuestionAnswerAfterSubmit(payload) {
    return {
        type: ActionTypes.UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT,
        payload: payload
    }
}

export function updateFormQuestionAnswerAfterSubmitSuccess(payload) {
    return {
        type: ActionTypes.UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT_SUCCESS,
        payload: payload
    }
}

export function updateFormQuestionAnswerAfterSubmitFail(payload) {
    return {
        type: ActionTypes.UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT_FAIL,
        payload: payload
    }
}

//action that requests application for the case type and sub case type combination given
export function requestGetApplication(caseTypeId, subCaseTypeId) {
    return {
        type: ActionTypes.REQUEST_GET_APPLICATION,
        payload: {
            caseTypeId: caseTypeId,
            subCaseTypeId: subCaseTypeId
        }
    }
}

//action that receives response from Get application
export function receiveGetApplication(application) {
    return {
        type: ActionTypes.RECEIVE_GET_APPLICATION,
        payload: application
    }
}

//action that receives bad request response from get application request
export function receiveBadRequestGetApplication(response) {
    return {
        type: ActionTypes.RECEIVE_BAD_REQUEST_GET_APPLICATION,
        payload: response
    }
}


//action that changes the redux fields
export function changeNewAppField(field, value) {
    return {
        type: ActionTypes.CHANGE_NEW_APPLICATION_FIELD,
        payload: {
            key: field,
            value: value
        }
    }
}

//action that changes the form data stored in redux
export function changeFormData(field, value) {
    return {
        type: ActionTypes.CHANGE_NEW_APPLICATION_FORM_DATA,
        payload: {
            key: field,
            value: value
        }
    }
}

//action that changes the required field data stored in redux
export function attachmentsChange(attachment) {
    return {
        type: ActionTypes.ATTACHMENTS_CHANGE,
        payload: attachment
    }
}

//action that changes the required field data stored in redux
export function attachmentRemove(attachmentIndex) {
    return {
        type: ActionTypes.ATTACHMENT_REMOVE,
        payload: attachmentIndex
    }
}


//action that requests post new application
export function requestPostNewApplication(application) {
    return {
        type: ActionTypes.REQUEST_POST_NEW_APPLICATION,
        payload: application
    }
}

//action that receives post new application response
export function receivePostNewApplication(response) {
    return {
        type: ActionTypes.RECEIVE_POST_NEW_APPLICATION,
        payload: response
    }
}

//action that receives bad request response
export function receiveBadRequestPostNewApp(response) {
    return {
        type: ActionTypes.RECEIVE_BAD_REQUEST_POST_NEW_APP,
        payload: response
    }
}


//action that updated the extra opponents in the redux
export function updateExtraOpponents(fieldKey, fieldValue, arrayKey) {
    return {
        type: ActionTypes.UPDATE_EXTRA_OPPONENTS,
        payload: {
            fieldKey,
            fieldValue,
            arrayKey
        }
    }
}

//action that updated the extra opponents in the redux
export function updateMedicalExpertFees(payload) {
    return {
        type: ActionTypes.UPDATE_MEDICAL_EXPERT_FEES,
        payload
    }
}

//action that requests patch saved app form
export function requestPatchApplication(savedApplication) {
    return {
        type: ActionTypes.REQUEST_PATCH_APPLICATION,
        payload: savedApplication
    }
}


//action that receives response patch saved app from
export function receivePatchApplication(response) {
    return {
        type: ActionTypes.RECEIVE_PATCH_APPLICATION,
        payload: response
    }
}

//action that receives bad request from patching application
export function receiveBadRequestPatchApplication(response) {
    return {
        type: ActionTypes.RECEIVE_BAD_REQUEST_PATCH_APPLICATION,
        payload: response
    }
}

//action that requests get selected application
export function requestGetSelectedApplication(appId) {
    return {
        type: ActionTypes.REQUEST_GET_SELECTED_APPLICATION,
        payload: appId
    }
}

//action that receives request get selected application response
export function receiveGetSelectedApplication(response) {
    return {
        type: ActionTypes.RECEIVE_GET_SELECTED_APPLICATION,
        payload: response
    }
}

//action that receives request get selected application response
export function receiveBadRequestGetSelectedApplication(response) {
    return {
        type: ActionTypes.RECEIVE_BAD_REQUEST_GET_SELECTED_APPLICATION,
        payload: response
    }
}


//action that requests delete drafted application
export function requestDeleteDraftedApplication(applicationId) {
    return {
        type: ActionTypes.REQUEST_DELETE_DRAFTED_APPLICATION,
        payload: applicationId
    }
}

//action that receives request delete drafted application response
export function receiveDeleteDraftedApplicationResponse(response) {
    return {
        type: ActionTypes.RECEIVE_DELETE_DRAFTED_APPLICATION_RESPONSE,
        payload: response
    }
}

//action that received the sub case types
export function receiveSubCaseTypesSelectedApp(subCaseTypes) {
    return {
        type: ActionTypes.RECEIVE_SUB_CASE_TYPES_SELECTED_APP,
        payload: subCaseTypes
    }
}

export function removeExtraOpponent(opponentId) {
    return {
        type: ActionTypes.REMOVE_EXTRA_OPPONENT,
        payload: opponentId
    }
}

//action that removes attachment
export function removeNewApplicationAttachment(attachmentId) {
    return {
        type: ActionTypes.REMOVE_NEW_APPLICATION_ATTACHMENT,
        payload: attachmentId
    }
}


export function requestGetSolicitorGroupWorkSources(payload) {
	return {
		type: ActionTypes.REQUEST_GET_SOLICITOR_GROUP_WORKSOURCES,
		payload
	}
}

export function receiveGetSolicitorGroupWorkSources(payload) {
	return {
		type: ActionTypes.RECEIVE_GET_SOLICITOR_GROUP_WORKSOURCES,
		payload
	}
}

export function receiveBadRequestGetSolicitorGroupWorkSources(payload) {
	return {
		type: ActionTypes.RECEIVE_BAD_REQUEST_GET_SOLICITOR_GROUP_WORKSOURCES,
		payload
	}
}
export function getPolicyAsSolicitor(payload) {
	return {
		type: ActionTypes.GET_POLICY_AS_SOLICITOR,
		payload
	}
}

export function requestPostNewApplicationAsSolicitor(application,username) {
    return {
        type: ActionTypes.REQUEST_POST_NEW_APPLICATION_AS_SOLICITOR,
        payload: {application,username}
    }
}